module.exports = __webpack_public_path__ + "static/media/check-green.7c6eaf4f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/check-green.svg
// module id = 1535
// module chunks = 0